/* eslint-disable @typescript-eslint/no-explicit-any */
import fetch from 'isomorphic-unfetch';

import { BASE_ENDPOINT } from '../constant';

export interface JpjRunningNumberProps {
  featured?: boolean;
}

export const getJpjRunningNumber = async (
  props: JpjRunningNumberProps
): Promise<any> => {
  const { featured } = props;
  const url = featured
    ? `${BASE_ENDPOINT}/is_feature_car_plate`
    : `${BASE_ENDPOINT}/car_plate`;

  try {
    if (!url) return {};
    const res = await fetch(url, {
      method: 'GET',
    });

    return res.json();
  } catch (error) {
    console.error('Fetch Error:', error);
    return {};
  }
};

export default getJpjRunningNumber;
